module.exports = __webpack_public_path__ + "media/landing_parts/icons/clever-2c00a2a6bc46203786d6fc80c6e897e2.png";